import i18n from 'src/i18n';

function findKeyInObject(obj: Record<string, any>, targetKey: string): string | null {
  for (const key of Object.keys(obj)) {
    const value = obj[key];

    if (key === targetKey && typeof value === 'string') {
      return value;
    }

    if (typeof value === 'object' && value !== null) {
      const found = findKeyInObject(value, targetKey);
      if (found) return found;
    }
  }

  return null;
}

function getCurrentLanguageResource(): Record<string, any> {
  const lang = i18n.language;

  return i18n.getResourceBundle(lang, 'translation');
}

export function resolveFieldLabel(fieldId: string): string {
  const resource = getCurrentLanguageResource();

  const found = findKeyInObject(resource, fieldId);

  return found ?? fieldId;
}

// ------------------------------------------------------------------------------------------------------------------------

function getObjectByPath(obj: any, path: string): any | undefined {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

/**
 * Finds the i18n translation key that matches the given localized label
 * under the specified translation path.
 *
 * Example:
 * reverseLookupByPath("EYLEM", 'administration.logs.fieldsEnum');  // "ACTION"
 */
export function reverseLookupByPath(label: string, path: string): string | undefined {
  const bundle = getCurrentLanguageResource();
  const target = getObjectByPath(bundle, path);

  if (!target || typeof target !== 'object') return;

  return Object.entries(target).find(([_, value]) => value == label)?.[0];
}
